import { createContext, useContext } from 'react';

// Lets the full-screen page (/agent) hand the chat back to the side panel or pop-up, which Layout owns.
const AgentPanelContext = createContext({ openPanel: () => {}, closeFullPage: () => {} });

export const AgentPanelProvider = AgentPanelContext.Provider;

export function useAgentPanel() {
  return useContext(AgentPanelContext);
}

export const AGENT_PAGE = '/agent';
export const VARIANT_KEY = 'afto-agent-view';
